import { useMutation } from "@tanstack/react-query";

import {
    disableAutoTopup,
} from "../services/payments";

export function useDisableAutoTopup() {

    return useMutation({

        mutationFn:
            disableAutoTopup,

    });

}